import React from 'react';
import onPeakLogo from '../../../img/onpeakLogo-clr.svg';

const Footer = (props) => {
	return (
		<div className='Footer d-flex justify-content-between align-items-center'>
			<img src={onPeakLogo} width='92' height='31'/>
			<div className='small ms-2'><small>Compass Reservation System is a registered trademark of onPeak</small></div>
		</div>
	);
};

export default new Footer();
